import { mapState } from 'vuex'
import axios from 'axios'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      lintAction: null,
      loading: false
    }
  },
  computed: {
    ...mapState({
      lintResults: (state) => state.TextLintStore.lintResults
    }),
    uuid: function () {
      return this.item.id || this.item.uuid
    }
  },
  destroyed () {
    if (typeof this.item.id !== 'number') this.deleteLintAction()
  },
  methods: {
    executeLint (text) {
      return () => {
        this.loading = true

        return () => {
          const query = {
            text: text
          }

          return new Promise((resolve, reject) => {
            if (this.notUpdated(text)) {
              this.loading = false
              return resolve()
            }

            axios
              .create()
              // eslint-disable-next-line no-undef
              .post(process.env.TEXTLINT_API_URL, query, {
                headers: {
                  // eslint-disable-next-line no-undef
                  'X-Api-Key': process.env.TEXTLINT_API_KEY
                }
              })
              .then(
                ({ data }) => {
                  this.$store.commit('TextLintStore/setLintResults', {
                    uuid: this.uuid,
                    result: data
                  })
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
              .finally(() => (this.loading = false))
          })
        }
      }
    },
    lintResult () {
      return this.lintResults[this.uuid]
    },
    notUpdated (text) {
      return this.lintResult() && text === this.lintResult()['original']
    },
    setLintAction (content) {
      this.lintAction = this.executeLint(content)
      this.$store.commit('TextLintStore/setItemLintAction', {
        uuid: this.uuid,
        action: this.lintAction
      })
    },
    deleteLintAction () {
      this.$store.commit('TextLintStore/deleteItemLintAction', {
        uuid: this.uuid
      })
      this.$store.commit('TextLintStore/deleteItemLintResult', {
        uuid: this.uuid
      })
    },
    previewContent (content) {
      let lintContent = content
      if (this.lintResult() && this.lintResult().result.length) {
        const highlightWords = []

        this.lintResult().result.map((detail) => {
          let word
          if (detail.message === '連続した三点リーダー(…)の数が偶数ではありません') return

          if (detail.fix) {
            word = {
              range: detail.fix.range,
              message: detail.message
            }
          } else if (typeof detail.index === 'number') {
            word = {
              range: [detail.index, detail.index + 1],
              message: detail.message
            }
          } else {
            return
          }

          this.appendOverlapLintMessage(word, highlightWords)
          highlightWords.push(word)
        })

        lintContent = this.highlightContent(lintContent, highlightWords)
      }
      return lintContent
    },
    highlightContent (lintContent, highlightWords) {
      let splitContent = lintContent.split('')
      highlightWords.map((value) => {
        const closeTagIndex =
          value.range[0] !== value.range[1]
            ? value.range[1] - 1
            : value.range[1]

        splitContent[value.range[0]] =
          `<span class="tooltip"><span>` + splitContent[value.range[0]]
        const message = value.message
          ? `<span class="description-top">${value.message}</span>`
          : ''
        splitContent[closeTagIndex] =
          splitContent[closeTagIndex] + `</span>${message}</span>`
      })
      return splitContent.join('')
    },
    // lintの対象範囲が被っている場合のメッセージを統合させる
    appendOverlapLintMessage (word, highlightWords) {
      const overlapWord = highlightWords.find(
        (item) =>
          item.range[0] <= word.range[0] && word.range[0] < item.range[1]
      )
      if (overlapWord) {
        overlapWord.message = overlapWord.message + '<br/>' + word.message
        word.message = undefined
      }
    },
    textLintAllowTagFormat (name) {
      return [
        `<---textlintMark-${name}--->\n `,
        `\n</---textlintMark-${name}---/>`
      ]
    }
  }
}
